export const filterContacts = (contacts = [], search) => {
    if(!search) return contacts;
    return contacts.filter(contact => {
        return JSON.stringify(contact).toLowerCase().includes(search.toLowerCase());
    })
}